export const VaultViewerAbi = [
  {
    type: 'function',
    inputs: [{ name: 'vault', internalType: 'address', type: 'address' }],
    name: 'rebalancingFlags',
    outputs: [{ name: 'flags', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'vault', internalType: 'address', type: 'address' },
      { name: 'snapshot', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'snapshotInfo',
    outputs: [
      { name: 'currencies', internalType: 'a160u96[]', type: 'uint256[]' },
      { name: 'currencySet', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'vault', internalType: 'address', type: 'address' }],
    name: 'stateInfo',
    outputs: [
      { name: 'latestSnapshot', internalType: 'uint256', type: 'uint256' },
      { name: 'currencies', internalType: 'Currency[]', type: 'address[]' },
    ],
    stateMutability: 'view',
  },
] as const
